import { Badge, Card, Link, Table, Title } from '@yoast/ui-library';

export const QueryHistoryCard = () => {
  return (
    <Card className="yst-mb-4">
      <Card.Content className="yst-flex yst-flex-col yst-gap-8">
        <Title size="2">Query - Best fish restaurant in Nijmegen</Title>

        <div>
          <p>AI Response:</p>
          <Link href="#todo">Show more</Link>
        </div>

        <div>
          <p>Extracted brands:</p>
          <Badge>Example</Badge>
          <Badge>Example</Badge>
          <Badge>Example</Badge>
          <Badge>Example</Badge>
          <Badge>Example</Badge>
        </div>

        <Table>
          <Table.Head>
            <Table.Row>
              <Table.Header>URL</Table.Header>
              <Table.Header>Associated brand</Table.Header>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <Link href="https://example.com" target="_blank">
                  https://example.com
                </Link>
              </Table.Cell>
              <Table.Cell>Example Brand</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <Link href="https://example2.com" target="_blank">
                  https://example2.com
                </Link>
              </Table.Cell>
              <Table.Cell>Example Brand 2</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Card.Content>
    </Card>
  );
};
